import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a14724b"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode(" 斯北图可靠性案例 | 鸿雁星座首发星 1100KM 24小时全时段运行 无失效 "), /*#__PURE__*/_createElementVNode("span", {
  class: "time"
}, "2023-04-26"), /*#__PURE__*/_createElementVNode("span", {
  class: "source"
}, "来源：空间中心效应室")], -1));
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "sep"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2018年12月，鸿雁星座首发星成功发射，", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "轨道高度1100公里，其辐射环境恶劣，", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "24小时全时段运行3年半，无失效。", -1));
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " “重庆号”是鸿雁星座的试验星，由航天科技集团五院深圳航天东方红卫星有限公司（原深圳航天东方红海特卫星有限公司）抓总研制。其功能密度和性能进一步提高，空间环境适应能力更强，为未来商业航天系统批量化低成本研制奠定了基础。 ", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 斯北图测控数传系列产品，很好地发挥核心部件制造优势，让客户聚焦卫星应用平台。其产品可以进行高度集成的一体化组装，确保后续卫星总体可以批量化应用。 ", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 值得一提的是：“重庆号”的轨道高度是1100KM，其辐射环境恶劣程度是500KM轨道的10倍。斯北图产品经过抗辐射设计和试验，保障其高可靠性。 ", -1));
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 斯北图产品设计的核心是突破工业化和宇航高可靠性设计的阻碍，按照工业化的设计理念改进产品，迅速应用到卫星上，与传统卫星反复调试检测不同，这大大缩短了时间周期，降低了成本。 ", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 斯北图凭借近20年积累的卫星通信技术和产品管理理念，公司自主安全的测控通信产品在国家卫星网络系统、国家传统卫星系统、欧洲卫星企业以及中国航天、中国电子、中科院、优势民营航天企业里成功应用。 ", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 2021年，斯北图完成110+配套产品的生产下线，具备标准化批量化生产的能力。而货架系列产品的推出，更是受到了老客户的支持。 ", -1));
const _hoisted_17 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "block",
    "width": "100%",
    "text-indent": "240px",
    "margin": "10px 0"
  }
}, "▲货架系列产品", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 工业化产品及技术如果要应用到传统航天领域，虽任重道远，但我们已经在前行的路上，从核心模组开始，到团队、市场和品牌建设，加速产品部署，目前成功跨入货架化批量化研产阶段。 ", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 未来，斯北图卫星坚持模块化的设计，与合作伙伴共同努力建设高标准卫星平台，为\"用卫星科技联接人与自然”的美好愿景而奋斗。 ", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mianze"
}, " 免责声明：本站文章版权归原作者及原出处所有 。如有侵权，请联系我们删除。 ", -1));
import img1 from '@/assets/news/news1-1.png';
import img2 from '@/assets/news/news1-2.jpeg';
import img3 from '@/assets/news/news1-3.png';
import img4 from '@/assets/news/news1-4.jpeg';
import img5 from '@/assets/news/news1-5.jpeg';
import img6 from '@/assets/news/news1-6.jpeg';
export default /*#__PURE__*/_defineComponent({
  __name: 'news2',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6, _createElementVNode("img", {
        style: {
          "width": "677px"
        },
        src: _unref(img1),
        alt: ""
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        style: {
          "width": "677px"
        },
        src: _unref(img2),
        alt: ""
      }, null, 8, _hoisted_8), _hoisted_9, _hoisted_10, _hoisted_11, _createElementVNode("img", {
        style: {
          "width": "410px"
        },
        src: _unref(img3),
        alt: ""
      }, null, 8, _hoisted_12), _createElementVNode("img", {
        style: {
          "width": "410px"
        },
        src: _unref(img4),
        alt: ""
      }, null, 8, _hoisted_13), _hoisted_14, _hoisted_15, _hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
        style: {
          "width": "284px"
        },
        src: _unref(img5),
        alt: ""
      }, null, 8, _hoisted_18), _createElementVNode("img", {
        style: {
          "width": "284px",
          "margin-left": "20px"
        },
        src: _unref(img6),
        alt: ""
      }, null, 8, _hoisted_19)]), _hoisted_20, _hoisted_21, _hoisted_22, _hoisted_23])], 64);
    };
  }
});